import React from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { Link } from 'react-router-dom'
import TutorHeader from '../TutorHeader/TutorHeader'

const TutorMyAssessmentMain = () => {
    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Assessments
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="study-material">
                                    <div className="row study-material-card-sec pt-3">
                                        {/* <div className="col-lg-3 col-md-6 mb-3">
                                            <Link to="/tutor/add-mock-objective-assessment" style={{ textDecoration: "none" }}>
                                                <div className="card" id="add-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="bi bi-file-earmark-richtext" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 mt-1">
                                                                    Add Mock
                                                                    <br />
                                                                    Assessment
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div> */}
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <Link to="/tutor/add-objective-assessment" style={{ textDecoration: "none" }}>
                                                <div className="card" id="add-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="bi bi-file-earmark-richtext" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 mt-1">
                                                                    Add New
                                                                    <br />
                                                                    Assessment
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <Link
                                                to="/tutor/completed-assessment"
                                                style={{ textDecoration: "none" }}
                                            >
                                                <div className="card" id="view-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="bi bi-file-earmark-richtext" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 mt-1">
                                                                    Completed
                                                                    <br />
                                                                    Assessment
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="col-lg-3 col-md-6 mb-3">
                                            <Link
                                                to="/tutor/view-assessment-course"
                                                style={{ textDecoration: "none" }}
                                            >
                                                <div className="card" id="view-study-tab">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 col-3">
                                                                <div className="icon-sec">
                                                                    <i className="bi bi-file-earmark-richtext" />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9 col-md-9 col-9">
                                                                <h5 className="mb-0 mt-1">
                                                                    View Added
                                                                    <br />
                                                                    Assessment
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorMyAssessmentMain